import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Divider,
  Card,
  Grid2,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import GuiasLateralBar from "./Views/GuiasLateralBar";
import GuiasToolsBars from "./Views/GuiasToolsBars";
import GuiasViewBody from "./Views/GuiasViewBody";
import * as XLSX from "xlsx";
import { styled, useTheme } from "@mui/material/styles";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import MenuIcon from "@mui/icons-material/Menu";
import useFindOrderBicciexpress from "../../../utils/UtilsOrders/useFindOrderBicciexpress";
import useFindOrderBicciexpressPendingPayment from "../../../utils/UtilsOrders/useFindOrderBicciexpressPendingPayment";
import { useDataProcessing } from "../../../hooks/useDataProcessing";
import { useDispatch } from "react-redux";
import { updateOrdersBicciexpressPayments } from "../../../redux/accionesOrders";
import { useDataProcessingProforma } from "../../../hooks/useDataProcessingProforma";
import generarReporteProformas from "../../../utils/Reports/generarReporteProformas";
import { useDataProcessingStates } from "../../../hooks/useDataProcessingStates";
import { useDataProcessingStatesApelaciones } from "../../../hooks/useDataProcessingStatesApelaciones";
import { fetcherUserSuportTickets } from "../../../utils/FectcherData/FectcherData";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const allowedExtensions = [".xlsx", ".xls", ".csv"];

const GuiasFacturacion = (props) => {
  const dispacth = useDispatch();

  const companyId = useMemo(() => {
    if (props.usuarioStorage) {
      return props.usuarioStorage.company;
    }
    return "";
  }, [props.usuarioStorage]);

  const drawerWidth = 240;
  const [initDate, setInitDate] = useState("");

  const [endDate, setEndDate] = useState("");

  const [modulesView, setModulesWiew] = useState("all");

  const [viewOrders, setViewOrder] = useState([]);

  const [dataPayment, setDataPayment] = useState([]);

  const [dataApelaciones, setDataApelaciones] = useState(null);

  const [dataStates, setDataStates] = useState(null);

  const [dataApe, setDataApe] = useState(null);

  const [isActive, setIsActive] = useState(false);

  const [isActiveUpdateProf, setisActiveUpdateProf] = useState(false);

  const [isActiveUpdateState, setIsActiveUpdateState] = useState(false);

  const [isActiveUpdateApe, setisActiveUpdateApe] = useState(false);

  const [menssaje, setMessaje] = useState("");

  const progress = useDataProcessing(viewOrders, isActive);

  const progressBilling = useDataProcessingProforma(
    dataPayment,
    isActiveUpdateProf
  );

  const progressState = useDataProcessingStates(
    dataStates,
    isActiveUpdateState
  );

  const progressApe = useDataProcessingStatesApelaciones(
    dataApe,
    isActiveUpdateApe
  );

  const { dataOrders, loading } = useFindOrderBicciexpress(
    companyId,
    initDate,
    endDate
  );

  const { dataOrdersPending, loadingPendints } =
    useFindOrderBicciexpressPendingPayment(companyId);

  useEffect(() => {
    // // console.log("Datos de salida", dataOrders, loading);
  }, [initDate, endDate, loading]);

  useEffect(() => {}, [dataPayment]);

  useEffect(() => {
    //  // console.log(menssaje);
    if (companyId) {
      getData(companyId);
    }
  }, [companyId, menssaje]);

  const getData = async () => {
    const tickets = await fetcherUserSuportTickets(companyId);

    let filtertickets = tickets.filter((item) => item.type === "billingTicket");

    if (filtertickets) {
      setDataApelaciones(filtertickets);
    } else {
      setDataApelaciones([]);
    }
  };

  const theme = useTheme();

  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const onChageRangePiker = (createDate, FinalDate) => {
    setInitDate(createDate.value);
    setEndDate(FinalDate.value);
  };

  const onClikBuscarCambios = (data) => {
    //  // console.log(viewOrders);
    if (viewOrders.length > 0) {
      setMessaje("");
      setIsActive(true);
    } else {
      //  // console.log("No hay registros seleccionado");
      setMessaje("No hay registros seleccionado");
      setIsActive(false);
    }
  };

  const loadDataPayment = () => {
    if (dataPayment && dataPayment.length > 0) {
      setMessaje("Archivo valido de proforma");
      setisActiveUpdateProf(true);
    } else {
      //   // console.log("No hay archivo de carga");
      setMessaje("No hay archivo de carga Facturación / Proforma");
      setisActiveUpdateProf(false);
    }
  };

  const loadDataState = () => {
    if (dataStates && dataStates.length > 0) {
      setMessaje("");
      setIsActiveUpdateState(true);
    } else {
      //  // console.log("No hay archivo de carga");
      setMessaje("No hay archivo de carga");
      setIsActiveUpdateState(false);
    }
  };

  const loadDataApe = () => {
    if (dataApe && dataApe.length > 0) {
      setMessaje("");
      setisActiveUpdateApe(true);
    } else {
      //    // console.log("No hay archivo de carga");
      setMessaje("No hay archivo de carga");
      setisActiveUpdateApe(false);
    }
  };

  const donwsLoadRegister = (data) => {
    // console.log(data);
  };

  const handleFileProforma = async (e) => {
    // console.log("Aqui Prof");

    const file = e.target.files[0];

    if (!file) {
      console.log("Ningún archivo seleccionado.");
      return;
    }

    const fileExtension = file.name
      .slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2)
      .toLowerCase();

    if (!allowedExtensions.includes(`.${fileExtension}`)) {
      console.error(`Archivo con extensión no permitida: .${fileExtension}`);
      setMessaje(`Extensión de archivo no permitida: .${fileExtension}`);
      return;
    }

    // console.log(file);
    const data = await file.arrayBuffer();
    const woskbook = XLSX.read(data);

    const worksheet = woskbook.Sheets["DATA"];
    let jsonData = XLSX.utils.sheet_to_json(worksheet);

    jsonData = jsonData.map((row) => {
      const cleanedRow = {};
      Object.keys(row).forEach((key) => {
        const trimmedKey = key.trim();
        cleanedRow[trimmedKey] = row[key];
      });
      return cleanedRow;
    });

    try {
      const paymentProforma = jsonData[0]["PaymentProforma"];
      const paymentValor = jsonData[0]["PaymentValor"];
      const paymentTipoServicio = jsonData[0]["PaymentType_service"];
      const bicciId = jsonData[0]["BICCIID"];
      // PaymentProforma // PaymentValor // PaymentType_service // BICCIID
      if (paymentProforma && paymentValor && paymentTipoServicio && bicciId) {
        setMessaje("un archivo seleccionado");
        console.log(jsonData);
        setDataPayment(jsonData);
        // props.setDocumentData(jsonData);
        // props.setDataType("billing");
        // props.setRender(!props.remder);
      } else {
        if (!paymentProforma) {
          setMessaje("No se encontro nombre paymentProforma");
          return;
        }

        if (!paymentValor) {
          setMessaje("No se encontro nombre paymentValor");
          return;
        }

        if (!paymentTipoServicio) {
          setMessaje("No se encontro nombre ");
          return;
        }

        if (!bicciId) {
          setMessaje("No se encontro nombre BICCIID");
          return;
        }

        setMessaje("Valido");
      }
    } catch (error) {
      setMessaje("No se encuentra la hoja con nombre DATA");
    }
  };

  const handleFileStates = async (e) => {
    //  // console.log("Aqui handle File States");

    if (e.target.files.length > 0) {
      setMessaje("seleccionado 1 Archivo");
    } else {
      setMessaje("Ningún archivo seleccionado.");
    }

    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const woskbook2 = XLSX.read(data);

    const worksheetState = woskbook2.Sheets["DATA_ESTADOS"];

    if (worksheetState) {
      const jsonDataSate = XLSX.utils.sheet_to_json(worksheetState);
      //    // console.log("Procesar Estados");

      try {
        const id = jsonDataSate[0]["ID"];
        const state = jsonDataSate[0]["ESTADO"];
        const baja = jsonDataSate[0]["BAJA"];
        const fecha = jsonDataSate[0]["FECHABAJA"];
        const comentario = jsonDataSate[0]["COMENTARIOBAJA"];
        const motivo = jsonDataSate[0]["MOTIVO"];
        if (id && state && baja && fecha) {
          setDataStates(jsonDataSate);
        } else {
          setMessaje(
            "Confirme el Nombre de las columnas  ID	ESTADO	BAJA	FECHABAJA	COMENTARIOBAJA	MOTIVO"
          );
        }
      } catch (error) {
        setMessaje("No se encuentra la hoja con nombre DATA_ESTADOS");
      }
    }
  };

  const handleFileApelacion = async (e) => {
    // console.log("Aqui handle File States");

    if (e.target.files.length > 0) {
      setMessaje("seleccionado 1 Archivo");
    } else {
      setMessaje("Ningún archivo seleccionado.");
    }

    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const woskbook3 = XLSX.read(data);

    const worksheetApe = woskbook3.Sheets["DATA_APELACIONES"];

    if (worksheetApe) {
      const jsonDataApe = XLSX.utils.sheet_to_json(worksheetApe);
      //  // console.log("Procesar Apelacion");
      //  // console.log(jsonDataApe);
      try {
        const id = jsonDataApe[0]["ID"];
        const State = jsonDataApe[0]["ESTADO"];
        const Size = jsonDataApe[0]["TALLA"];
        const alto = jsonDataApe[0]["ALTO"];
        const ancho = jsonDataApe[0]["ANCHO"];
        const largo = jsonDataApe[0]["LARGO"];
        const mt3 = jsonDataApe[0]["M3"];
        if (id && State && Size) {
          setDataApe(jsonDataApe);
        } else {
          setMessaje(
            "Confirme el Nombre de las columnas  ID // ESTADO // TALLA // ALTO // ANCHO // LARGO // M3"
          );
        }
      } catch (error) {
        setMessaje("No se encuentra la hoja con nombre DATA_APELACIONES");
      }
    }
  };

  const onSelectView = (e) => {
    setModulesWiew(e);
  };

  const exportartReportePagos = (data) => {
    generarReporteProformas(data);
  };

  return (
    <Grid2 celled="internally" id="expresscuentaContent">
      <Grid2>
        <Grid2
          computer={16}
          mobile={16}
          tablet={16}
          className="dash-container-colmun"
        >
          <Card className="typeMiniforms">
            <Box
              sx={{
                padding: "20px",
                width: "100%",
                minHeight: "100%",
                height: "100%",
                backgroundColor: "#f8f8f8",
                margin: "0px",
              }}
            >
              {/* Barra superior */}
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  backgroundColor: "#F8F8F8",
                }}
              >
                <Typography variant="h3" sx={{ m: 2 }}>
                  Facturación{" "}
                  {/* <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={handleDrawerOpen}
                    edge="start"
                    sx={{ mr: 2, ...(open && { display: "none" }) }}
                  >
                    <MenuIcon />
                  </IconButton> */}
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    float: "right !important",
                    right: "5% !important",
                    marginRight: "5% !important",
                  }}
                >
                  {progress ? `${progress.toFixed(2)}%` : null}
                  {progressBilling ? `${progressBilling.toFixed(2)}%` : null}
                  {progressState ? `${progressState.toFixed(2)}%` : null}

                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={() => {
                      setIsActive(!isActive);
                      setMessaje("");
                    }}
                    edge="start"
                    sx={{ m: 2, ...(open && { display: "none" }) }}
                  >
                    {progress && isActive ? (
                      <>
                        <PauseCircleIcon /> Pausar
                      </>
                    ) : (
                      <>
                        <PlayCircleIcon /> Actualizar
                      </>
                    )}
                  </IconButton>
                </Typography>
                <Typography
                  variant="span"
                  sx={{
                    position: "absolute",
                    float: "right !important",
                    right: "5% !important",
                    marginRight: "5% !important",
                  }}
                >
                  {"_> "}
                  {menssaje}
                </Typography>
              </Box>
              <Box>
                <Grid2
                  sx={{
                    height: "100%",
                    width: open ? `calc(100% - ${drawerWidth + 5}px)` : "100%",
                    border: "1px solid  grey",
                  }}
                >
                  <Grid2
                    item
                    sx={{
                      border: "2px solid #030303",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <GuiasToolsBars
                      onChageRangePiker={onChageRangePiker}
                      onSelectView={onSelectView}
                    />
                  </Grid2>
                  <Grid2
                    item
                    sx={{
                      border: "2px solid green",
                      width: "100%",
                      height: "auto",
                    }}
                  >
                    <GuiasViewBody
                      modulesView={modulesView}
                      initDate={initDate}
                      endDate={endDate}
                      dataOrders={dataOrders}
                      loading={loading}
                      dataOrdersPending={dataOrdersPending}
                      loadingPendints={loadingPendints}
                      viewOrder={viewOrders}
                      setViewOrder={setViewOrder}
                      onClikBuscarCambios={onClikBuscarCambios}
                      exportartReportePagos={exportartReportePagos}
                      handleFileProforma={handleFileProforma}
                      handleFileStates={handleFileStates}
                      handleFileApelacion={handleFileApelacion}
                      loadDataPayment={loadDataPayment}
                      loadDataState={loadDataState}
                      loadDataApe={loadDataApe}
                      dataApelaciones={dataApelaciones}
                      donwsLoadRegister={donwsLoadRegister}
                    />
                  </Grid2>
                </Grid2>
                {/* 
                <Drawer
                  sx={{
                    width: drawerWidth,
                    marginTop: "72px !important",
                    flexShrink: 0,
                    "& .MuiDrawer-paper": {
                      width: drawerWidth,
                      boxSizing: "border-box",
                    },
                  }}
                  variant="persistent"
                  anchor="right"
                  open={open}
                >
                  <DrawerHeader>
                    <IconButton onClick={handleDrawerClose}>
                      {theme.direction === "ltr" ? (
                        <ChevronLeftIcon />
                      ) : (
                        <ChevronRightIcon />
                      )}
                    </IconButton>
                  </DrawerHeader>
                  <Divider />
                  <List>
                    {["Inbox", "Starred", "Send email", "Drafts"].map(
                      (text, index) => (
                        <ListItem key={text} disablePadding>
                          <ListItemButton>
                            <ListItemIcon>
                              {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                            </ListItemIcon>
                            <ListItemText primary={text} />
                          </ListItemButton>
                        </ListItem>
                      )
                    )}
                  </List>
                  <Divider />
                  <List>
                    {["All mail", "Trash", "Spam"].map((text, index) => (
                      <ListItem key={text} disablePadding>
                        <ListItemButton>
                          <ListItemIcon>
                            {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                          </ListItemIcon>
                          <ListItemText primary={text} />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </List>
                </Drawer>
                 */}
              </Box>
            </Box>
          </Card>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default GuiasFacturacion;
